export default __webpack_public_path__ + "static/media/cabin.44173302.png";